var map = {
	"./2026-06-12-clean-text-is-the-wrong-target.md": 8346,
	"./2026-06-8-why-these-looseleafs-exist.md": 9973,
	"./2026-09-01-llm-consistency-in-extraction.md": 8417,
	"./2026-09-09-getting-data-out-of-the-argentine-state.md": 1855,
	"./2026-09-14-the-list-price-is-not-the-price.md": 7764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6817;